var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.37336 8.80503H10.0057L14 12.8073L12.8073 14L8.80503 10.0057V9.37336L8.58891 9.14923C7.67639 9.93368 6.49171 10.4059 5.20297 10.4059C2.32933 10.4059 0 8.07662 0 5.20297C0 2.32933 2.32933 0 5.20297 0C8.07662 0 10.4059 2.32933 10.4059 5.20297C10.4059 6.49171 9.93368 7.67639 9.14923 8.58891L9.37336 8.80503ZM1.60091 5.20297C1.60091 7.19611 3.20983 8.80503 5.20297 8.80503C7.19611 8.80503 8.80503 7.19611 8.80503 5.20297C8.80503 3.20983 7.19611 1.60091 5.20297 1.60091C3.20983 1.60091 1.60091 3.20983 1.60091 5.20297Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGlass);
export default __webpack_public_path__ + "static/media/search-glass.a82d27e0444b3a02760a34a1c0c28c2f.svg";
export { ForwardRef as ReactComponent };